import {Component, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {LoadingService} from "../../../../services/loading.service";
import * as XLSX from "xlsx";
import {AllDailyChildOccupancyComponent} from "./all-daily-child-occupancy/all-daily-child-occupancy.component";
import {MatDialog} from "@angular/material/dialog";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

export interface OccupancyReport {
  available: number;
  centreCode: string;
  date: any
  occupied: number;
  totalOccupancy: number
}

export interface MonthlyOccupancyRow {
  month: string;
  occupied: number;
  totalOccupancy: number;
  available: number;
  percentage: number;
  partialTill?: string;
}

export interface YearlyOccupancy {
  year: number;
  units: number;
  rows: MonthlyOccupancyRow[];
}

@Component({
  selector: 'app-occupancy-reports',
  templateUrl: './occupancy-reports.component.html',
  styleUrls: ['./occupancy-reports.component.scss']
})
export class OccupancyReportsComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  startDate1: Date | null = null;
  endDate1: Date | null = null;
  occupancyReports: OccupancyReport[] = [];
  centres$: Observable<Centre[]>;
  // selectedCentreCode: any = ''
  // selectedCentre: Centre | null = null;

  selectedCentreCode: string[] = [];   // supports multi-select
  selectedCentre: Centre[] = [];       // supports multi-select

  centres: Centre[] = [];
  displayedColumns: string[] = ['Sr', 'centreName', 'date', 'totalOccupancy', 'occupied', 'available', 'percentage'];
  dataSource!: MatTableDataSource<OccupancyReport>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  viewMode: 'daily' | 'monthly' = 'daily';
  monthlyColumns: string[] = ['sr', 'month', 'occupied', 'totalOccupancy', 'available', 'percentage'];
  yearlySummary: YearlyOccupancy[] = [];

  constructor(private firestore: AngularFirestore,
              private mCentreService: CentreService,
              private dialog: MatDialog,
              private loadingService: LoadingService,
              private readonly financialYearService: FinancialYearService,) {
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe((centres) => {
      this.centres = centres;
    });
  }


  // Add this method for displayWithFn
  displayCentre = (centre: Centre): string => {
    return centre ? centre.centreName : '';
  }

  // Add this method for selection change
  // onCentreSelect(selectedCentre: Centre) {
  //   if (!selectedCentre) {
  //     this.selectedCentre = null;
  //     this.selectedCentreCode = '';
  //     return;
  //   }
  //
  //   console.log("Selected Centre:", selectedCentre);
  //   this.selectedCentre = selectedCentre;
  //   // Update selectedCentreCode to maintain compatibility with existing logic
  //   this.selectedCentreCode = selectedCentre.centreCode;
  // }

  onCentreSelect(selectedCentre: Centre | Centre[]) {

    if (!selectedCentre || (Array.isArray(selectedCentre) && selectedCentre.length === 0)) {
      this.selectedCentre = [];
      this.selectedCentreCode = [];
      return;
    }

    // Normalize to array
    const centres = Array.isArray(selectedCentre) ? selectedCentre : [selectedCentre];

    this.selectedCentre = centres;
    this.selectedCentreCode = centres.map(c => c.centreCode);

    console.log('Selected Centres:', this.selectedCentreCode);
  }


  // Method to get centreName by centreCode
  getCentreNameByCode(centreCode: string): string {
    const centre = this.centres.find(c => c.centreCode === centreCode);
    return centre ? centre.centreName : 'Unknown Centre';  // Return 'Unknown Centre' if not found
  }


  onEndDateChanged() {

  }

  // SearchData() {
  //   this.loadingService.setLoading(true);
  //   if (!this.startDate1 || !this.endDate1 || !this.selectedCentreCode) {
  //     alert('Please select a valid date range and center.');
  //     this.loadingService.setLoading(false);
  //     return;
  //   }
  //
  //
  //   this.firestore.collection<OccupancyReport>('occupancy').valueChanges({idField:'id'}).subscribe((data: OccupancyReport[]) => {
  //     const adjustedEndDate = new Date(this.endDate1!);
  //     adjustedEndDate.setHours(23, 59, 59, 999);
  //     const filteredData = data.filter((res: OccupancyReport) => {
  //       const reportDate = res.date.toDate().getTime();
  //       const startDate = this.startDate1!.getTime();
  //       const endDate = adjustedEndDate.getTime();
  //       const isCenterMatched = this.selectedCentreCode === '' || this.selectedCentreCode.length === 0 || this.selectedCentreCode.includes(res.centreCode);
  //       this.loadingService.setLoading(false);
  //       return reportDate >= startDate && reportDate <= endDate && isCenterMatched;
  //     });
  //
  //     this.occupancyReports = filteredData;
  //     this.dataSource = new MatTableDataSource(this.occupancyReports);
  //     this.dataSource.paginator = this.paginator;
  //     this.loadingService.setLoading(false);
  //   });
  //   this.getTotalPercentage()
  // }
  //
  // clearAll() {
  //   this.startDate1 = null;
  //   this.endDate1 = null;
  //   this.occupancyReports = [];
  //   this.dataSource = new MatTableDataSource(this.occupancyReports);
  //   this.dataSource.paginator = this.paginator;
  //   this.selectedCentreCode = ''
  // }


  // SearchData() {
  //   this.loadingService.setLoading(true);
  //
  //   if (!this.startDate1 || !this.endDate1) {
  //     alert('Please select a valid date range.');
  //     this.loadingService.setLoading(false);
  //     return;
  //   }
  //
  //   this.firestore
  //     .collection<OccupancyReport>('occupancy')
  //     .valueChanges({ idField: 'id' })
  //     .subscribe((data: OccupancyReport[]) => {
  //
  //       const adjustedEndDate = new Date(this.endDate1!);
  //       adjustedEndDate.setHours(23, 59, 59, 999);
  //
  //       const filteredData = data.filter(res => {
  //         const reportDate = res.date.toDate().getTime();
  //
  //         const isDateMatched =
  //           reportDate >= this.startDate1!.getTime() &&
  //           reportDate <= adjustedEndDate.getTime();
  //
  //         const isCenterMatched =
  //           this.selectedCentreCode.length === 0 ||
  //           this.selectedCentreCode.includes(res.centreCode);
  //
  //         return isDateMatched && isCenterMatched;
  //       });
  //
  //       this.occupancyReports = filteredData;
  //       this.dataSource = new MatTableDataSource(this.occupancyReports);
  //       this.dataSource.paginator = this.paginator;
  //
  //       this.loadingService.setLoading(false);
  //     });
  //
  //   this.getTotalPercentage();
  // }

  SearchData() {
    this.loadingService.setLoading(true);

    //  Date validation (existing logic)
    if (!this.startDate1 || !this.endDate1) {
      alert('Please select a valid date range.');
      this.loadingService.setLoading(false);
      return;
    }

    //  NEW: Centre selection validation
    if (!this.selectedCentreCode || this.selectedCentreCode.length === 0) {
      alert('Please select centre.');
      this.loadingService.setLoading(false);
      return;
    }

    this.firestore
      .collection<OccupancyReport>('occupancy')
      .valueChanges({ idField: 'id' })
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: OccupancyReport[]) => {

        const adjustedEndDate = new Date(this.endDate1!);
        adjustedEndDate.setHours(23, 59, 59, 999);

        const filteredData = data.filter(res => {
          const reportDate = res.date.toDate().getTime();

          const isDateMatched =
            reportDate >= this.startDate1!.getTime() &&
            reportDate <= adjustedEndDate.getTime();

          const isCenterMatched =
            this.selectedCentreCode.includes(res.centreCode);

          return isDateMatched && isCenterMatched;
        });

        this.occupancyReports = filteredData;
        this.dataSource = new MatTableDataSource(this.occupancyReports);
        this.dataSource.paginator = this.paginator;
        this.yearlySummary = this.buildYearlySummary(filteredData);

        this.loadingService.setLoading(false);
      });

    this.getTotalPercentage();
  }



  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.occupancyReports = [];
    this.dataSource = new MatTableDataSource(this.occupancyReports);
    this.dataSource.paginator = this.paginator;

    this.selectedCentreCode = [];
    this.selectedCentre = [];
    this.yearlySummary = [];
  }

  /**
   * Month-wise average occupancy: daily values are summed across the selected centres per date,
   * then averaged over the days recorded in each month. Percentage uses unrounded averages.
   */
  buildYearlySummary(data: OccupancyReport[]): YearlyOccupancy[] {
    const perDay = new Map<string, { date: Date, occupied: number, total: number }>();
    data.forEach(r => {
      const d: Date = r.date.toDate();
      const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
      const day = perDay.get(key) || {date: d, occupied: 0, total: 0};
      day.occupied += r.occupied || 0;
      day.total += r.totalOccupancy || 0;
      perDay.set(key, day);
    });

    const perMonth = new Map<string, { year: number, month: number, occupied: number, total: number, days: number, lastDay: number }>();
    perDay.forEach(day => {
      const y = day.date.getFullYear(), m = day.date.getMonth();
      const key = `${y}-${m}`;
      const agg = perMonth.get(key) || {year: y, month: m, occupied: 0, total: 0, days: 0, lastDay: 0};
      agg.occupied += day.occupied;
      agg.total += day.total;
      agg.days++;
      agg.lastDay = Math.max(agg.lastDay, day.date.getDate());
      perMonth.set(key, agg);
    });

    const now = new Date();
    const years = new Map<number, YearlyOccupancy>();
    Array.from(perMonth.values())
      .sort((a, b) => a.year - b.year || a.month - b.month)
      .forEach(m => {
        const avgOccupied = m.occupied / m.days;
        const avgTotal = m.total / m.days;
        const monthLabel = new Date(m.year, m.month, 1)
          .toLocaleString('en-GB', {month: 'short'}) + '-' + String(m.year).slice(2);
        const isCurrentMonth = m.year === now.getFullYear() && m.month === now.getMonth();
        const row: MonthlyOccupancyRow = {
          month: monthLabel,
          occupied: Math.round(avgOccupied),
          totalOccupancy: Math.round(avgTotal),
          available: Math.round(avgTotal - avgOccupied),
          percentage: avgTotal ? (avgOccupied / avgTotal) * 100 : 0,
          partialTill: isCurrentMonth ?
            `Till ${String(m.lastDay).padStart(2, '0')}.${String(m.month + 1).padStart(2, '0')}.${m.year}` : undefined
        };
        const y = years.get(m.year) || {year: m.year, units: 0, rows: []};
        y.units = Math.max(y.units, row.totalOccupancy);
        y.rows.push(row);
        years.set(m.year, y);
      });
    return Array.from(years.values());
  }

  exportMonthlyExcel(): void {
    if (!this.yearlySummary.length) {
      return;
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    this.yearlySummary.forEach(y => {
      const rows = y.rows.map((r, i) => ({
        'Sr No.': i + 1,
        Month: r.month + (r.partialTill ? ` (${r.partialTill})` : ''),
        Occupied: r.occupied,
        'Total Occupancy': r.totalOccupancy,
        Available: r.available,
        Percentage: r.percentage.toFixed(2) + '%'
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      ws['!cols'] = Object.keys(rows[0]).map(() => ({wch: 18}));
      XLSX.utils.book_append_sheet(wb, ws, `Year ${y.year}`);
    });
    XLSX.writeFile(wb, 'Occupancy-Monthly-Report.xlsx');
  }


  protected readonly Math = Math;

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const centreName = this.getCentreNameByCode(data.centreCode).toLowerCase(); // Get centre name
      return centreName.includes(filter); // Check if it matches filter value
    };
    this.dataSource.filter = filterValue; // Apply filter
  }

  exportexcel(): void {
    if (!this.dataSource || !this.dataSource.data) {
      console.error('No data available to export.');
      return;
    }

    // Convert dataSource to JSON format for Excel export
    const jsonData = this.dataSource.data.map((item, index) => ({
      Sr: index + 1,
      'Centre Name': this.getCentreNameByCode(item.centreCode),
      Date: item.date.toDate().toLocaleDateString('en-GB'), // Format Date
      Occupied: item.occupied,
      'Total Occupancy': item.totalOccupancy,
      Available: item.available,
      Percentage: ((item.occupied / item.totalOccupancy) * 100).toFixed(2) + '%'
    }));

    // Add footer totals row at the end
    jsonData.push({
      Sr: Number('Total'),
      'Centre Name': '',
      Date: 'Total:',
      Occupied: this.getTotal('occupied'),
      'Total Occupancy': this.getTotal('totalOccupancy'),
      Available: this.getTotal('available'),
      Percentage : this.getTotalPercentage().toFixed(2) + '%'
    });

    // Convert to worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);

    // Auto-adjust column width
    const wsCols = Object.keys(jsonData[0]).map(() => ({ wch: 20 }));
    ws['!cols'] = wsCols;

    // Create workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Occupancy-Report.xlsx');
  }

  getFooterColumns(): string[] {
    return ['Sr', 'centreName', 'date', 'totalOccupancy', 'occupied', 'available', 'percentage'];
  }

  getTotal(field: keyof OccupancyReport): number {
    return this.dataSource?.data?.reduce((acc, curr) => acc + (curr[field] as number || 0), 0) || 0;
  }

  getTotalPercentage(): number {
    const totalOccupied = this.getTotal('occupied');
    const totalOccupancy = this.getTotal('totalOccupancy');
    return totalOccupancy ? (totalOccupied / totalOccupancy) * 100 : 0;
  }

  selectedRow(row: any) {
    console.log('Selected Row Data:', row);
    // Open the modal and pass row data to it
    const dialogRef = this.dialog.open(AllDailyChildOccupancyComponent, {
      data: row, // Pass the selected row data to the modal
      width: '900px',  // Set width
      height: '500px', // Set height
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
